
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetOwnerWorkerVersionQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher
  ) {}
  
  async run(): Promise<any> {
    let data = await this.dispatcher.dispatch('get.owner.worker.version', {})
    return data
  }
}